import { render, staticRenderFns } from "./reply-form.vue?vue&type=template&id=01ab4272&scoped=true&"
import script from "./reply-form.vue?vue&type=script&lang=js&"
export * from "./reply-form.vue?vue&type=script&lang=js&"
import style0 from "./reply-form.vue?vue&type=style&index=0&id=01ab4272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab4272",
  null
  
)

export default component.exports